let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fbaif")).then(() => parcelRequire('4p2gE'));